// extracted by mini-css-extract-plugin
export default {"switch":"Switcher_switch__Rv4rA","handle":"Switcher_handle__qqKpG"};